import { Injectable, EventEmitter } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { NotifyMessageModel } from '../interfaces/notifyMessageModel';

const resources = {
  PRENOTAZIONI: "PRENOTAZIONI",
  NEWS: "NEWS",
  SEDI: "SEDI",
  SETTING: "SETTING",
  USER: "USER",
  NOTIFY: "NOTIFY",
  EVENTI: "EVENTI"
}

const actions = {
  UPDATE_RESOURCE: "UPDATE_RESOURCE"
}

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  public updateStoreReconnected: EventEmitter<void> = new EventEmitter();

  constructor(private socket: Socket) {
    console.log('SocketService constructor');
    socket.on('connect', () => {
      console.log("connesso al socket");
      this.updateStoreReconnected.emit();
    });
    socket.on('disconnect', (reason) => {
      console.log("disconnesso dal socket", reason);
    });
  }

  public isConnected(): boolean {
    return !!(this.socket && (this.socket as any).ioSocket && (this.socket as any).ioSocket.connected);
  }

  public ensureConnected(): void {
    try {
      if (!this.isConnected()) {
        console.log('[SocketService] ensureConnected: tentativo di riconnessione socket...');
        this.socket.connect();
      }
    } catch (e) {
      console.warn('[SocketService] ensureConnected failed', e);
    }
  }

  receiveUpdatePrenotazioni(): Observable<any> {
    return this.socket.fromEvent(`${resources.PRENOTAZIONI}${actions.UPDATE_RESOURCE}`);
  }

  receiveUpdateNews(): Observable<any> {
    return this.socket.fromEvent(`${resources.NEWS}${actions.UPDATE_RESOURCE}`);
  }

  receiveUpdateUser(): Observable<any> {
    return this.socket.fromEvent(`${resources.USER}${actions.UPDATE_RESOURCE}`);
  }

  receiveUpdateSedi(): Observable<any> {
    return this.socket.fromEvent(`${resources.SEDI}${actions.UPDATE_RESOURCE}`);
  }

  receiveNotify(): Observable<NotifyMessageModel> {
    return this.socket.fromEvent(`${resources.NOTIFY}${actions.UPDATE_RESOURCE}`);
  }

  receiveUpdateEventi(): Observable<any> {
    return this.socket.fromEvent(`${resources.EVENTI}${actions.UPDATE_RESOURCE}`);
  }
}
